import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import FractionalCMO from '../components/FractionalCMO';
import CaseStudies from '../components/CaseStudies';
import ReviewsSection from '../components/ReviewsSection';
import FocusCallout from '../components/FocusCallout';
import '../styles/custom.css';
import GHLWidget from "../components/GHLWidget";

const HomePage = () => {
  return (
    
    <div className="page-wrapper">
      <GHLWidget />
      <Header />
      <Hero />
      <AboutUs />
      <FractionalCMO />
      <CaseStudies />
      <ReviewsSection />
      <FocusCallout />
    </div>
  );
}

export default HomePage;